import React, { useState } from "react";
import { useEffect } from "react";
import { useCallback } from "react";
import { Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API, defaultLimitPagination, get } from "../../../config";
import Pagination from "../../common/Pagination";
import { formatName } from "../../common/Misc";
// import { debounce } from "lodash";
import InvitationsActionButton from "./components/InvitationsActionButton";
import Spin from "../../common/Spin";
import InviteBuilderModal from "../../Builders/Builders/components/InviteBuilderModal";
import SearchBox from "../../common/SearchBox";
import { debounce } from "lodash";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faCheckCircle,
//   faXmarkCircle,
// } from "@fortawesome/free-solid-svg-icons";

// In Accounting Page (Invitation From Builder)
const Invitation = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [invitationsList, setInvitationsList] = useState();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");

  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [showInviteBuilder, setShowInviteBuilder] = useState(false);

  // *API Call for Fetch Invitation from Builder - Start
  const fetchInvitations = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.GET_INVITATIONS}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }`
        );
        setLoading(false);
        setLimit(data?.data?.invitations?.per_page);
        setPage(data?.data?.invitations?.current_page);
        setTotal(data?.data?.invitations?.total);
        setFrom(data?.data?.invitations?.from);
        setTo(data?.data?.invitations?.to);
        const invitationList = data?.data?.invitations?.data;
        setInvitationsList(invitationList);
        return data.data;
      } catch (error) {
        setLoading(false);
        setInvitationsList([]);

        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam]
  );

  const handleInvitations = () => {
    fetchInvitations(limit, page);
  };

  useEffect(() => {
    fetchInvitations();
  }, [fetchInvitations]);
  // *API Call for Fetch Invitation from Builder - End

  // *Invitation Table Row and Column Generation, Filtering and Sorting of Record - Start
  const invitationGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: invitationsList[i]?.id,
        date: invitationsList[i]?.created_at
          ? invitationsList[i]?.created_at
          : "",
        invitation_id: invitationsList[i]?.id,
        invited_by: invitationsList[i]?.invited_by ? (
          <div>
            {formatName(
              invitationsList[i]?.invited_by?.first_name,
              invitationsList[i]?.invited_by?.last_name
            )}
          </div>
        ) : (
          ""
        ),
        invite_for: invitationsList[i]?.builder_project?.project_name ? (
          parseInt(invitationsList[i]?.status) === 1 ? (
            <Link
              to={{
                pathname: `/projects/${invitationsList[i]?.builder_project?.id}`,
              }}
            >
              {invitationsList[i]?.builder_project?.project_name}
            </Link>
          ) : (
            invitationsList[i]?.builder_project?.project_name
          )
        ) : (
          ""
        ),
        email: invitationsList[i]?.invited_by?.email
          ? invitationsList[i]?.invited_by?.email
          : "",
        status: invitationsList[i]?.status
          ? (parseInt(invitationsList[i]?.status) === 1 && "Accepted") ||
            (parseInt(invitationsList[i]?.status) === 2 && "Rejected") ||
            (parseInt(invitationsList[i]?.status) === 0 && "-")
          : "",
        action: (
          <InvitationsActionButton
            id={invitationsList[i]?.id}
            handleInvitations={handleInvitations}
            status={invitationsList[i]?.status}
          />
        ),
      });
    }
    return items;
  };
  const invitations = invitationGenerator(invitationsList?.length);

  useEffect(() => {
    navigate(
      `/user-settings?tab=invitations&childTab=invitations-from-builder&limit=${
        limit ? limit : defaultLimitPagination
      }&page=${page ? page : 1}&search=${searchParam ? searchParam : ""}`,
      {
        replace: true,
      }
    );
  }, [navigate, limit, searchParam, page]);

  const columns = [
    {
      dataField: "date",
      text: "Date",
    },
    {
      dataField: "invited_by",
      text: "Invited By",
    },
    {
      dataField: "invite_for",
      text: "Invite For",
    },
    {
      dataField: "email",
      text: "Email",
    },
    {
      dataField: "status",
      text: "Status",
      headerAlign: "center",
      align: "center",
      className: "text-center",
      style: { width: "127px" },
    },
    {
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchInvitations(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchInvitations(limit, page);
  };
  // *Invitation Table Row and Column Generation, Filtering and Sorting of Record - End

  const handleInviteBuilder = () => {
    setShowInviteBuilder(!showInviteBuilder);
  };
  return (
    <>
      {/* <div className="content-details"> */}
      <div className="table-top-btn">
        <SearchBox
          placeholder={"Search Invitation"}
          searchParamData={searchParamData}
          handleSearchChange={handleSearchChange}
          handleClearSearch={handleClearSearch}
        />
        <div className="table-btn">
          <Button
            className="small"
            onClick={() => {
              handleInviteBuilder();
            }}
          >
            Request Access from a Builder
          </Button>
        </div>
      </div>
      <div className="custom-table">
        {loading && <Spin />}
        <BootstrapTable
          keyField="key"
          remote
          data={invitations}
          columns={columns}
          noDataIndication="No Data Found"
        />

        <Pagination
          total={total}
          limit={parseInt(limit)}
          currentPage={page}
          updateLimit={handleUpdateLimit}
          updatePage={handleChangePage}
          from={from}
          to={to}
        />
      </div>
      {/* </div> */}
      {showInviteBuilder && (
        <InviteBuilderModal
          showInviteBuilder={showInviteBuilder}
          handleInviteBuilder={handleInviteBuilder}
        />
      )}
    </>
  );
};

export default Invitation;
